<template>
  <main
    class="tw-w-full tw-flex tw-flex-col tw-items-center tw-pb-8 md:tw-px-0 md:tw-px-0 add-bank"
  >
    <div
      v-if="showLinkBank"
      class="tw-flex tw-flex-col tw-items-center md:tw-max-w-[524px] tw-mt-[58px]"
    >
      <h1
        class="tw-font-bold tw-tracking-[-0.1px] tw-text-secondary tw-text-2xl tw-mb-8"
      >
        Link your Bank Account
      </h1>
      <div
        class="add-bank__card tw-rounded-[10px] tw-bg-white tw-py-8 tw-px-8 md:tw-px-[74px] tw-w-full tw-max-w-[524px] tw-mx-auto"
      >
        <BankOptions :show="true" @bank-method-selected="processMethod" />

        <NordigenBanks
          v-if="nodigenModal"
          :show="nodigenModal"
          @close-modal="nodigenModal = false"
          @trigger-loader="toggleLoader"
        />
        <div v-if="linkToken">
          <PlaidLink
            clientName="GetEquity"
            :env="plaidEnv"
            :link_token="linkToken"
            :products="['auth', 'transactions']"
            :onSuccess="onPlaidSuccess"
            :onExit="onPlaidExit"
            :onEvent="onPlaidEvent"
          >
            <div class="tw-mt-3" v-if="showPlaidButton">
              <p
                class="tw-text-[medium] tw-leading-[125%] tw-text-[#234160] tw-inline-flex"
              >
                If you're not redirected to Plaid,
                <span ref="plaidLink" class="tw-text-primary tw-cursor-pointer"
                  >click to proceed</span
                >
              </p>
            </div>
          </PlaidLink>
        </div>
        <!-- <p v-if="loadingMessage" class="tw-text-center tw-mt-2">
        {{ loadingMessage }}
      </p> -->
        <router-link
          :to="{ name: 'Setup' }"
          class="tw-mt-8 tw-text-[medium] tw-leading-[125%] tw-text-[#234160] tw-text-center tw-block"
        >
          Skip for now
        </router-link>
      </div>
    </div>
    <section
      v-else
      class="tw-rounded-[10px] tw-bg-white tw-py-7 tw-px-7 tw-text-center add-bank__section tw-max-w-[610px]"
    >
      <div class="">
        <h1 class="tw-text-secondary tw-font-bold tw-mb-3 tw-text-[22px]">
          Link your bank account
        </h1>
        <p class="tw-text-[#4F5877] tw-mb-6 tw-font-normal">
          GetEquity needs you to link your bank account. We're committed to
          working with our partners to make payments easier, regardless of your
          location
        </p>
        <div class="tw-max-w-[288px] tw-mx-auto">
          <img
            class="tw-block tw-mx-auto"
            src="https://res.cloudinary.com/djalafcj9/image/upload/v1655461132/getequityV2/Frame_42891_qbamw2.png"
          />
          <ul class="tw-mt-6">
            <li
              v-for="(reason, index) in reasons"
              :key="index"
              class="tw-flex tw-mb-8 tw-text-left tw-gap-x-2"
            >
              <img
                src="https://res.cloudinary.com/djalafcj9/image/upload/v1653916132/getequityV2/Vector_si2wy8.svg"
                class="tw-w-5 tw-h-5"
              />
              <div class="">
                <p class="tw-text-secondary tw-mb-1 tw-font-normal">
                  {{ reason.title }}
                </p>
                <p class="tw-text-[#4F5877] tw-text-sm tw-font-thin">
                  {{ reason.text }}
                </p>
              </div>
            </li>
          </ul>
        </div>
        <button
          @click="showLinkBank = true"
          class="tw-bg-primary tw-h-[55px] tw-w-full tw-max-w-[400px] tw-font-medium tw-rounded tw-text-white"
        >
          Continue
        </button>
        <router-link :to="{ name: 'Setup' }">
          <span
            class="tw-w-[60px] tw-text-[#4F5877] tw-mt-7 tw-leading-[22px] tw-block tw-mx-auto"
            >Skip</span
          >
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
  import BankOptions from "@/components/general/BankOptions";
  import Connect from "@mono.co/connect.js";
  import bankApi from "@/utils/mono";
  import responseHandler from "@/utils/responseHandler.js";
  import NordigenBanks from "@/components/general/NordigenBanks";
  import PlaidLink from "vue-plaid-link2";
  import { mapActions } from "vuex";

  export default {
    name: "AddBank",
    components: {
      BankOptions,
      NordigenBanks,
      PlaidLink,
    },
    data() {
      return {
        showLinkBank: false,
        monoConnect: null,
        loadingMessage: "",
        show: false,
        nodigenModal: false,
        linkToken: "",
        plaidEnv: process.env.VUE_APP_PLAID_ENV,
        plaidSuccess: false,
        showPlaidButton: false,
        reasons: [
          {
            title: "Secure",
            text: "The transfer of your data is encrypted end-to-end",
          },
          {
            title: "Private",
            text: "Your credentials will never be made accessible to this application",
          },
        ],
      };
    },
    watch: {
      linkToken(val) {
        if (val.length > 0) {
          this.setLoading(true);
          this.showPlaidButton = true;
          setTimeout(() => {
            this.setLoading(false);
            this.$refs.plaidLink.click();
          }, 1000);
        }
      },
    },
    mounted() {
      if (
        (this.$route.query.scope && this.$route.query.state) ||
        this.$route.query.state
      ) {
        // If we're sent from stitch
        this.handleStitchFinalResponse();
      }
      if (this.$route.query.ref) {
        // If we're sent from nordigen
        this.handleNordigenFinalResponse();
      }
    },
    methods: {
      ...mapActions(["showToast", "setLoading"]),
      async processMethod(method) {
        switch (method) {
          case "MonoKenya":
            this.monoConnect = await this.setupMono("ke");
            this.monoConnect.open();
            break;
          case "Mono":
            this.monoConnect = await this.setupMono("ng");
            this.monoConnect.open();
            break;
          case "MonoGhana":
            this.monoConnect = await this.setupMono("gh");
            this.monoConnect.open();
            break;
          case "Stitch":
            this.connectForeignAccount("stitch");
            break;
          case "Nordigen":
            this.nodigenModal = true;
            this.show = false;
            break;
          case "Plaid":
            this.connectForeignAccount("plaid");
            this.show = false;
            break;
          case "Manual":
            this.$router.push({ name: "AddBankManual" });
            break;
        }
      },
      /**
       * @param {string} type
       * @param {object} data
       */
      async generalSuccessHandler(type, data) {
        try {
          const response = await bankApi.finalizeBankConnection(type, data);
          if (response.status === 201 || response.status === 200) {
            this.setLoading(false);
            this.showToast({
              description: "Bank connection was successful",
              display: true,
              type: "success",
            });
            this.show = false;
          } else {
            this.setLoading(false);
            responseHandler.handleError(response);
          }
          this.$router.push({ name: "Setup" });
        } catch (error) {
          this.setLoading(false);
          responseHandler.handleError(error);
        }
      },
      onPlaidLoad() {
        console.log("Plaid Loaded");
      },
      onPlaidSuccess(publicToken) {
        if (!this.plaidSuccess) {
          this.linkToken = "";
          this.generalSuccessHandler("plaid", { code: publicToken });
          this.plaidSuccess = true;
        }
      },
      onPlaidExit() {
        this.linkToken = "";

        this.setLoading(false);
      },
      onPlaidEvent(e) {
        if (e === "HANDOFF") {
          this.getBankAccounts();
        }
      },

      setupMono(country) {
        // eslint-disable-next-line prefer-const
        let self = this;
        let key = null;
        switch (country) {
          case "ng":
            key = process.env.VUE_APP_MONO_BUSINESS;
            break;
          case "ke":
            key = process.env.VUE_APP_MONO_KE_PERSONAL;
            break;
          case "gh":
            key = process.env.VUE_APP_MONO_GH_BUSINESS;
            break;
        }
        const monoInstance = new Connect({
          onSuccess: function (code) {
            self.setLoading(true);
            code.country = country;
            self.generalSuccessHandler("mono", code);
          },
          key,
        });
        monoInstance.setup();
        return monoInstance;
      },
      toggleLoader(val) {
        this.setLoading(val);
      },
      handlePlaidInitiationResponse(response) {
        this.plaidSuccess = false;
        this.linkToken = response.data.data.link;
      },
      handleStitchInitiationResponse(response) {
        const { link, state, verifier } = response.data.data;
        localStorage.setItem(state, verifier);
        window.location = link;
        this.loadingMessage = "Redirecting...";
      },
      async connectForeignAccount(type) {
        this.setLoading(true);
        this.loadingMessage = "Please wait...";
        try {
          let response = null;
          switch (type) {
            case "stitch":
              const currentUrl = `${window.location.origin}/onboarding/add-bank`;
              response = await bankApi.initiateBankConnection("stitch", {
                redirectUri: currentUrl,
              });
              break;
            case "plaid":
              response = await bankApi.initiateBankConnection(type);
          }
          if (response.status === 201 || response.status === 200) {
            this.setLoading(false);
            ((
              {
                stitch: () => this.handleStitchInitiationResponse(response),
                plaid: () => this.handlePlaidInitiationResponse(response),
              }[type] || (() => {})
            )());
          } else {
            this.setLoading(false);
            responseHandler.handleError(response.data);
          }
        } catch (error) {
          this.setLoading(false);
          responseHandler.handleError(error);
        }
      },
      async handleStitchFinalResponse() {
        if (
          !this.$route.query.code ||
          (!this.$route.query.code && this.$route.query.state)
        ) {
          this.showToast({
            description: "We could not complete this integration.",
            display: true,
            type: "error",
          });
          this.$router.push({
            name: "AddBank",
          });
        } else {
          const currentUrl = `${window.location.origin}/onboarding/add-bank`;
          const data = {
            verifier: localStorage.getItem(this.$route.query.state),
            code: this.$route.query.code,
            redirectUri: currentUrl,
          };
          this.setLoading(true);
          try {
            await bankApi.finalizeBankConnection("stitch", data);
            this.showToast({
              description: "Bank connection was successful",
              display: true,
              type: "success",
            });
            this.$router.push({
              name: "OverviewDetails",
            });
            this.setLoading(false);
          } catch (error) {
            this.$router.push({
              name: "AddBank",
            });
            this.setLoading(false);
            responseHandler.handleError(error);
          }
        }
      },
      async handleNordigenFinalResponse() {
        if (this.$route.query.error) {
          this.showToast({
            description: "We could not complete this integration.",
            display: true,
            type: "error",
          });
          this.$router.push({
            name: "AddBank",
          });
        } else {
          const data = {
            code: this.$route.query.ref,
          };
          this.setLoading(true);
          try {
            await bankApi.finalizeBankConnection("nordigen", data);
            this.setLoading(false);
            this.showToast({
              description: "Bank connection was successful",
              display: true,
              type: "success",
            });
            this.$router.push({
              name: "Setup",
            });
          } catch (error) {
            this.setLoading(false);
            responseHandler.handleError(error);
            this.$router.push({
              name: "AddBank",
            });
          }
        }
      },
      loadError() {
        this.showToast({
          description: "Your Integration attempt failed.",
          display: true,
          type: "error",
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .add-bank {
    &__card,
    &__section {
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    }
  }
</style>
